import * as React from "react";
import { Button, Menu, Dropdown, Icon } from "antd";

export interface State {}

export interface Props {
  translate: any;
  onRemoveBtnClick?: any;
  onCreateBtnClick?: any;
  onAddQualifierBtnClick?: any;
}

export default class FormSectionActionsBar extends React.Component<
  Props,
  State
> {
  get menu() {
    const {
      translate,
      onRemoveBtnClick,
      onCreateBtnClick,
      onAddQualifierBtnClick
    } = this.props;
    return (
      <Menu>
        <Menu.Item key="1" onClick={onAddQualifierBtnClick}>
          {translate("form_section_actions_bar.add_qualifier")}
        </Menu.Item>
        <Menu.Item key="2" onClick={onCreateBtnClick}>
          {translate("form_section_actions_bar.add")}
        </Menu.Item>
        <Menu.Item key="3" onClick={onRemoveBtnClick} style={{ color: "red" }}>
          {translate("form_section_actions_bar.remove")}
        </Menu.Item>
      </Menu>
    );
  }
  render() {
    const { translate } = this.props;

    return (
      <Dropdown overlay={this.menu}>
        <Button>
          {translate("form_section_actions_bar.actions_label")}{" "}
          <Icon type="down" />
        </Button>
      </Dropdown>
    );
  }
}
